import React, { Component } from "react";
import Datatable from "../../../common/datatable";
import store, { history } from "../../../../store";
import { connect } from "react-redux";

class HoAccountTable extends Component {
  render() {
    const columns = [
      { prop: "ho-account-number", title: "HO Account Number", width: "300" },
      {
        prop: "active",
        title: "Active",
        width: "150",
        format(data, _) {
          return (data) ? 'Y' : 'N';
        }
      },
    ];

    const actions = [
      {
        label: "Edit",
        permissions: {
          action: "modify",
          subjectClass: "HoAccount",
        },
        callback: (row) => {
          history.push(`/admin/ho-accounts/${row.id}/edit`);
        },
      },
      {
        label: "View account managers",
        callback: (row) => {
          history.push(`/admin/ho-accounts/${row.id}/account-managers`);
        },
      },
    ];

    return (
      <div>
        <Datatable
          data={this.props.hoAccounts}
          dataSize={this.props.paging.number * this.props.paging.size}
          columns={columns}
          actions={actions}
          hideId={false}
          pagination={{
            page: this.props.currentPage,
            sizePerPage: 20,
            onPageChange: this.props.onPageChange,
          }}
          remote
        />
      </div>
    );
  }
}

export default connect()(HoAccountTable);



// WEBPACK FOOTER //
// ./src/components/admin/ho-accounts/list/table.jsx